var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.selectedCustomer && _vm.mails && _vm.mails.length > 0
      ? _c("div", { staticClass: "d-flex-align-center d-flex-column" }, [
          _c("h1", { staticClass: "title mt-10" }, [
            _vm._v(" " + _vm._s(_vm.selectedCustomer.name) + " "),
          ]),
          _c("div", { staticClass: "hero is-primary bar" }, [
            _c(
              "div",
              { staticClass: "mt-10 d-flex-justify-center container" },
              [
                _vm.lastDeclaration
                  ? _c("custom-box", {
                      attrs: { mail: _vm.lastDeclaration },
                      on: { "see-declaration": _vm.seeDeclaration },
                    })
                  : _vm._e(),
                _vm.lastDeclaration
                  ? _c("custom-box", {
                      attrs: {
                        "second-card": true,
                        mail: _vm.lastMail,
                        "asking-declaration":
                          _vm.lastDeclaration !== _vm.lastMail,
                      },
                      on: {
                        "see-declaration": _vm.seeDeclaration,
                        spontaneousDeclaration: _vm.spontaneousDeclaration,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "d-flex-align-center d-flex-column d2" }),
          _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _c("b-loading", {
                attrs: { active: _vm.collectLoading, "is-full-page": false },
                on: {
                  "update:active": function ($event) {
                    _vm.collectLoading = $event
                  },
                },
              }),
              _vm.nextCollect && _vm.nextCollect.length > 0
                ? _c(
                    "div",
                    { staticClass: "next-collect-card has-background-primary" },
                    [
                      _c("span", { staticClass: "subtitle card-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("consignee.pickup_management.next_collect")
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex-row d-flex-justify-center d-flex-space-around card-body",
                        },
                        [
                          _c("span", [
                            _c(
                              "span",
                              [
                                _c("b-icon", {
                                  attrs: { icon: "calendar", type: "is-dark" },
                                }),
                              ],
                              1
                            ),
                            _c("span", { staticClass: "subtitle is-dark" }, [
                              _vm._v(" " + _vm._s(_vm.$t("global.date")) + " "),
                            ]),
                            _c("br"),
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.nextCollect[0].loadingDate
                                      ? _vm
                                          .$dayjs(
                                            _vm.nextCollect[0].loadingDate
                                          )
                                          .format("DD/MM/YYYY")
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("br"),
                          _c(
                            "span",
                            [
                              _c(
                                "span",
                                [
                                  _c("b-icon", {
                                    attrs: { icon: "box", type: "is-dark" },
                                  }),
                                ],
                                1
                              ),
                              _c("span", { staticClass: "subtitle is-dark" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "consignee.pickup_management.materials"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _vm._l(_vm.nextCollect, function (col) {
                                return _c(
                                  "div",
                                  { key: col.id },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          col.mat === "GPS52"
                                            ? col.mat.slice(0, -1)
                                            : col.mat
                                        ) +
                                        " "
                                    ),
                                    _c("b-icon", {
                                      attrs: { icon: "arrow-right" },
                                    }),
                                    _vm._v(" " + _vm._s(col.qty) + " "),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ])
      : _c("div", [
          _c("div", { staticClass: "hero is-danger bar d-flex-align-center" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("consignee.pickup_management.no_data_available")
                  ) +
                  " "
              ),
            ]),
          ]),
        ]),
    _vm.declaration
      ? _c(
          "div",
          [
            _c("declaration", {
              attrs: { "selected-mail-declaration": _vm.declaration },
              on: { close: _vm.closeDeclaration },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }